export default __webpack_public_path__ + "static/media/checkmark.6d0b0609.svg";